export {BrandService} from './brand.service'
export {BrandComponent} from './brand.component'
export {BrandListComponent} from './brand-list/brand-list.component'
export {BrandEditComponent} from './brand-edit/brand-edit.component'



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/brand/index.ts